import React from 'react'
import styles from './style.module.css'
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { HiOutlineBolt } from "react-icons/hi2";
import { TbBuildingBroadcastTower } from "react-icons/tb";
import { FaDollarSign } from "react-icons/fa";
import { MdOutlineManageHistory } from "react-icons/md";
import { TbCalendarCog } from "react-icons/tb";

//i wnat to pass the content as props

interface Product2Props {
  type: 'software' | 'hardware';
}

const Product_2 : React.FC<Product2Props> = ({ type }) => {
    let softwareContent = 
    (
        <div className=''>
            <div className={styles['product2-heading']}>
                Key Software Advantages
            </div>
              <div className={styles['product2-content-container']}>
                  <div className={styles['product2-content']}>
                      <div className={styles['product2-content-icon-container']}>
                        
                        <span className={styles['product2-content-icon-span']}>

                        </span>
                        <div className={styles['product2-content-icon']}>
                            <FaDollarSign />
                        </div>
                      </div>
                      <div className={styles['product2-content-header']}>
                          Pricing
                      </div>
                      <div className={styles['product2-content-body']}>
                          Our management solution is priced so that we win when you win. 
                          That’s why our software doesn’t have any annual or monthly subscription fees.
                      </div>
                  </div>
                  <div className={styles['product2-content']}>
                      <div className={styles['product2-content-icon-container']}>
                        
                        <span className={styles['product2-content-icon-span']}>

                        </span>
                        <div className={styles['product2-content-icon']}>
                            <MdOutlineManageHistory />
                        </div>
                      </div>
                      <div className={styles['product2-content-header']}>
                          Management
                      </div>
                      <div className={styles['product2-content-body']}>
                          Fully managed by BreatheEV, 
                          our CSMS ensures maximum uptime through proactive monitoring and remote diagnostics.

                      </div>
                  </div>
                  <div className={styles['product2-content']}>
                      <div className={styles['product2-content-icon-container']}>
                        
                        <span className={styles['product2-content-icon-span']}>

                        </span>
                        <div className={styles['product2-content-icon']}>
                            <TbCalendarCog />
                        </div>
                      </div>
                      <div className={styles['product2-content-header']}>
                          Flexibility
                      </div>
                      <div className={styles['product2-content-body']}>
                          Customizable software lets you enable reservations, 
                          set dynamic pricing, and tailor access rules to your property's needs.
                      </div>
                  </div>
              </div>
          </div>
    )

    let hardwareContent = (
        <div className='container'>
            <div className={styles['product2-heading']}>
                Key Hardware Advantages
            </div>
              <div className={styles['product2-content-container']}>
                  <div className={styles['product2-content']}>
                      <div className={styles['product2-content-icon-container']}>
                        
                        <span className={styles['product2-content-icon-span']}>

                        </span>
                        <div className={styles['product2-content-icon']}>
                            <IoShieldCheckmarkOutline />
                        </div>
                      </div>
                      <div className={styles['product2-content-header']}>
                          Reliability
                      </div>
                      <div className={styles['product2-content-body']}>
                          99.8% uptime guarantee with
                          redundant systems and continuous monitoring.
                      </div>
                  </div>
                  <div className={styles['product2-content']}>
                      <div className={styles['product2-content-icon-container']}>
                        
                        <span className={styles['product2-content-icon-span']}>

                        </span>
                        <div className={styles['product2-content-icon']}>
                            <HiOutlineBolt />
                        </div>
                      </div>
                      <div className={styles['product2-content-header']}>
                          Smart Design
                      </div>
                      <div className={styles['product2-content-body']}>
                          Space-efficient with integrated cable management
                          and intuitive user interface.
                      </div>
                  </div>
                  <div className={styles['product2-content']}>
                      <div className={styles['product2-content-icon-container']}>
                        
                        <span className={styles['product2-content-icon-span']}>

                        </span>
                        <div className={styles['product2-content-icon']}>
                            <TbBuildingBroadcastTower />
                        </div>
                      </div>
                      <div className={styles['product2-content-header']}>
                          Connectivity
                      </div>
                      <div className={styles['product2-content-body']}>
                          Seamless integration with our software platform
                          for complete management capabilities.
                      </div>
                  </div>
              </div>
          </div>
    )
  return (
    <div className={styles['product2-main-container']}>
        {
            type === 'software' ? softwareContent : hardwareContent
        }
    </div>
  )
}

export default Product_2